export enum AuthResponseStatusEnum {
  Ok = 'OK',
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  MfaCodeSent = 'MFA_CODE_SENT',
}
